import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const NumberCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>{rowData.number}</Text>
                <Text>
                    {rowData.carrier}
                    {rowData.upstreamCarrier !== rowData.carrier ? (
                        <Badge
                            ms={'xs'}
                            size={'sm'}>
                            {rowData.upstreamCarrier}
                        </Badge>
                    ) : (
                        <Badge
                            ms={'xs'}
                            size={'sm'}
                            color={'gray'}>
                            Non-MVNO
                        </Badge>
                    )}
                </Text>
            </Stack>
        </Box>
    );
};

const NumberColumn = () => ({
    accessorKey: 'numberFormatted',
    header: 'Number / Carrier',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NumberCell cell={cell} />,
});
export default NumberColumn;
